import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import { Container as DropButton } from '@propertypal/web-ui/src/buttons/DropButton.style';
import { Container as SelectInput } from '@propertypal/web-ui/src/inputs/SelectInput.style';
import { Input as TextInputInput } from '@propertypal/web-ui/src/inputs/TextInput.style';
import styled from 'styled-components';

export const BREAKPOINT = '780px';

export const Container = styled.div`
  position: relative;
  z-index: 5;
  max-width: 760px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
`;

export const SearchForm = styled.form<{ instantVal?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => platform.select(theme.white, 'none')};
  padding: 6px;
  border-radius: ${platform.select(50, 6)}px;

  ${TextInputInput} {
    height: 54px;

    &::placeholder {
      color: ${({ theme }) => theme.backgroundLight};
    }

    &::selection {
      color: ${({ theme }) => theme.white};
      background: ${({ theme }) => theme.primary};
    }
  }
`;

export const SearchInputContainer = styled.div`
  flex: 1;
`;

export const SearchButtons = styled.div<{ multiButtons?: boolean }>`
  display: flex;
  flex-basis: 180px;
  gap: 10px;

  ${DropButton} {
    height: 54px;
  }

  ${SelectInput} {
    margin-left: 6px;
  }

  @media (${mobileXXLargeMax}) {
    flex-basis: 54px;
  }
`;

export const TabRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  font-size: 18px;
  color: ${({ theme }) => theme.white};
  border-bottom: 3px solid ${({ theme, $active }) => ($active ? theme.primary : 'transparent')};
  font-weight: bold;
  margin: 15px 15px 10px;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  padding: 5px 0;

  @media (${mobileXXLargeMax}) {
    margin: 10px;
    font-size: 16px;
  }
`;

export const SearchText = styled.span`
  svg {
    display: none !important;
  }

  @media (${mobileXXLargeMax}) {
    svg {
      display: block !important;
    }

    span {
      display: none;
    }
  }
`;
